module.exports = __webpack_public_path__ + "static/media/si-speartip.d0d38112.png";